import { baselineOrder, initSelection, pinSelectedFirst, SelectionPage } from "./meta_ads/selection";

const idOf = (card: HTMLElement) => card.dataset.campaignId;

function reorder(ids: string[]): void {
  const grid = document.querySelector(".arf-page .ad-grid");
  if (!grid) return;

  const cards = baselineOrder(Array.from(grid.querySelectorAll<HTMLElement>(".adcard[data-campaign-id]")));
  pinSelectedFirst(grid, cards, ids, idOf);

  // The "New ad campaign" tile trails the cards.
  const tile = grid.querySelector(".adcard-new");
  if (tile) grid.appendChild(tile);
}

function summarise(ids: string[]): void {
  const withSelection = document.getElementById("arf-camp-selected");
  const withoutSelection = document.getElementById("arf-camp-unselected");
  if (!withSelection || !withoutSelection) return;

  const count = document.getElementById("arf-camp-selected-count");
  const unit = document.getElementById("arf-camp-selected-unit");
  if (count) count.textContent = String(ids.length);
  if (unit) unit.textContent = ids.length === 1 ? "campaign" : "campaigns";

  withSelection.classList.toggle("d-none", ids.length === 0);
  withoutSelection.classList.toggle("d-none", ids.length > 0);
}

const CAMPAIGNS: SelectionPage = {
  param: "selected_campaign_ids",
  root: "[data-campaign-selection]",
  item: ".adcard[data-campaign-id]",
  toggle: ".ad-check",
  idOf,
  // The tab strip, the page body (cards, filters, pager) and the header search.
  containers: [".arf-tabs", ".arf-page", ".meta-ad-search-bar"],

  paint: (card, selected) => {
    card.classList.toggle("selected", selected);

    const check = card.querySelector(".ad-check");
    if (!check) return;

    check.classList.toggle("on", selected);
    check.setAttribute("title", selected ? "Deselect campaign" : "Select campaign");
  },

  reflect: (ids) => {
    reorder(ids);
    summarise(ids);
  },
};

export function initAdCampaignSelection(): void {
  initSelection(CAMPAIGNS);
}
